import { MODEL_NAMES } from '../constants/index';
import { buildContacts } from '../utils/messaging/conversation';
import { service } from '@ember/service';
import MessagingBase from './messaging-base';

export default class MessagingConversation extends MessagingBase {
  @service intl;
  @service messaging;
  @service store;

  urlForCreateRecord() {
    const include = encodeURIComponent('users,last_message');
    return super.urlForCreateRecord(...arguments) + `?include=${include}`;
  }

  fetchAndValidateUsers(conversation) {
    const baseUrl = this.buildURL(MODEL_NAMES.CONTACT);
    return fetch(`${baseUrl}/batch-create`, {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify({
        data: buildContacts(conversation, this.messaging.currentProfile),
      }),
    });
  }

  async addMembers(conversation, { members, historyMode }) {
    const include = encodeURIComponent('users,last_message');
    const url = `${this.buildURL(MODEL_NAMES.CONVERSATION, conversation.id)}/users?include=${include}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify({
        data: {
          type: 'conversations',
          relationships: {
            users: {
              data: members.map(member => ({
                type: 'users',
                attributes: {
                  'external_id': member.externalId,
                  'external_scope': member.externalScope,
                  name: member.name,
                },
              })),
            },
          },
        },
        meta: { history_mode: historyMode },
      }),
    });

    if (!response.ok) {
      throw new Error(this.intl.t('emc.general_error'));
    }

    return response.json();
  }

  async leave(conversationId) {
    const url = `${this.buildURL(MODEL_NAMES.CONVERSATION, conversationId)}/leave`;
    const response = await fetch(url, {
      method: 'POST',
      headers: this.headers,
    });

    if (!response.ok) {
      throw new Error(`Leave conversation failed: ${response.status}`);
    }
  }

  async discard(conversationId) {
    const url = this.buildURL(MODEL_NAMES.CONVERSATION, conversationId);
    const response = await fetch(url, {
      method: 'DELETE',
      headers: this.headers,
    });

    if (!response.ok) {
      throw new Error(`Discard conversation failed: ${response.status}`);
    }
  }

  async updateDisplayName(conversationId, displayName) {
    const url = this.buildURL(MODEL_NAMES.CONVERSATION, conversationId);
    const response = await fetch(url, {
      method: 'PATCH',
      headers: this.headers,
      body: JSON.stringify({
        data: {
          type: 'conversations',
          id: conversationId,
          attributes: {
            'display_name': displayName ?? null,
          },
        },
      }),
    });

    if (!response.ok) {
      throw new Error(this.intl.t('emc.general_error'));
    }

    this.store.push({
      data: {
        id: conversationId,
        type: MODEL_NAMES.CONVERSATION,
        attributes: {
          displayName: displayName ?? null,
        },
      },
    });
  }
}
